// extracted by mini-css-extract-plugin
export default {"user_info":"userInfo_user_info__RdS3M","user_info_none":"userInfo_user_info_none__M6f4I","message-chat-back-button":"userInfo_message-chat-back-button__ppVUH"};